import type { Flag } from './types';

// DISMISS

export const DISMISS = 'state.flags.DISMISS' as const;

export type DismissFlagAction = {
	type: typeof DISMISS;
	payload: string;
};

export const dismissFlagAction = (flagId: string): DismissFlagAction => ({
	type: DISMISS,
	payload: flagId,
});

// ADD

export const ADD = 'state.flags.ADD' as const;

export type AddFlagAction = {
	type: typeof ADD;
	payload: Flag;
};

export const addFlagAction = (flag: Flag): AddFlagAction => ({
	type: ADD,
	payload: flag,
});
